package com.exura.features.publicplans.domain.usecase

import com.exura.features.publicplans.domain.model.AnonymousPublicPlanOrder
import com.exura.features.publicplans.domain.repository.ProviderPublicPlanRepository
import kotlinx.coroutines.flow.Flow

class GetPublicPlanOrdersUseCase(
    private val repository: ProviderPublicPlanRepository,
) {
    suspend operator fun invoke(id: String): Result<Flow<List<AnonymousPublicPlanOrder>>> = runCatching {
        repository.getPublicPlanOrders(id)
    }
}
